<template>
    <div v-if="bannerText" class="announcement-banner" :style="marginTop">
        <i v-if="bannerIcon" :class="[themeSetting('result_page_banner_icon'), 'banner-icon']"></i>

        <div class="banner-text" v-html="bannerText"></div>
    </div>
</template>

<script>
export default {
    props: ['filtersPresent'],
    computed: {
        bannerIcon() {
            return this.themeSetting('result_page_banner_icon')
        },
        bannerText() {
            return this.themeSetting('result_page_banner_text')
        },
        marginTop() {
            return this.filtersPresent ? '' : 'margin-top: 16px;'
        },
    },
}
</script>

<style lang="scss">
@import '~scss/mixins/rem';

.announcement-banner {
    background-color: var(--result-page-banner-background-color);
    border-radius: 5px;
    padding: 10px 20px;
    color: var(--result-page-banner-text-color);
    margin-bottom: 16px;
    display: flex;
    align-items: center;

    .banner-text {
        display: inline-block;

        p {
            font-size: rem(14px);
            margin-bottom: 0;
            color: var(--result-page-banner-text-color);
            display: inline-block;
        }
    }

    .banner-icon {
        display: flex;
        font-size: rem(18px);
        margin-right: 10px;
        display: inline-block;
    }
}
</style>
